import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Clock, Target, Rocket, RefreshCw } from 'lucide-react';
const reasons = [{
  icon: <Clock className="text-blue-600" data-id="element-248" />,
  title: 'RECUPERA TU TIEMPO',
  desc: 'Todo está organizado para que puedas seleccionar, imprimir y comenzar a trabajar sin preparar cada clase desde cero.'
}, {
  icon: <Target className="text-blue-600" data-id="element-249" />,
  title: 'CONTENIDO ADAPTABLE',
  desc: 'Los temas corresponden a los principales ejes de Física de educación secundaria y pueden adaptarse al programa educativo de cada país.'
}, {
  icon: <Rocket className="text-blue-600" data-id="element-250" />,
  title: 'FÍSICA APLICADA',
  desc: 'Incluye ejemplos cotidianos, experimentos de bajo costo y situaciones problemáticas que facilitan la comprensión.'
}, {
  icon: <RefreshCw className="text-blue-600" data-id="element-251" />,
  title: 'ACTUALIZACIONES INCLUIDAS',
  desc: 'Recibirás las mejoras y nuevos recursos incorporados a la Bóveda VIP sin pagos adicionales.'
}];
export function WhyChoose() {
  return <section className="py-8 md:py-20 px-4 bg-blue-50/50" data-id="element-252">
      <div className="max-w-6xl mx-auto" data-id="element-253">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-slate-900 mb-6 md:mb-16" data-id="element-254">
          ¿Por qué elegir el Mega Pack?
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-255">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-3xl border border-blue-100 shadow-xl shadow-blue-900/5 flex flex-col items-center text-center group hover:border-blue-300 transition-colors" data-id="element-256">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-257">
                {cloneElement(reason.icon as React.ReactElement, {
              size: 28
            })}
              </div>
              <h3 className="text-lg md:text-xl font-black text-slate-900 mb-3 leading-tight" data-id="element-258">
                {reason.title}
              </h3>
              <p className="text-slate-600 text-sm md:text-base font-medium leading-relaxed" data-id="element-259">
                {reason.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}